import WarehousesPage from '@/modules/warehouses/WarehousesPage';
import WarehouseDetailsPage from '@/modules/warehouses/WarehouseDetailsPage';
import { UserRole } from '@nova/core';
import i18n from '@/plugins/i18n.js';

export default [
  {
    path: '/warehouses',
    name: 'warehouses',
    component: WarehousesPage,
    props: true,
    meta: {
      title: () => i18n.global.t('routes.pageTitles.warehouses'),
      requiresAuth: true,
      maxRole: UserRole.OWNER
    }
  },
  {
    path: '/warehouses/:warehouseId/general',
    name: 'warehouses.details.general',
    component: WarehouseDetailsPage,
    props: true,
    meta: {
      preventTitleReset: true,
      requiresAuth: true,
      maxRole: UserRole.OWNER,
      title: i18n.global.t('routes.pageTitles.warehouseDetails')
    }
  },
  {
    path: '/warehouses/:warehouseId/operating-hours',
    name: 'warehouses.details.operatingHours',
    component: WarehouseDetailsPage,
    props: true,
    meta: {
      preventTitleReset: true,
      requiresAuth: true,
      maxRole: UserRole.OWNER,
      title: i18n.global.t('routes.pageTitles.warehouseOperatingHours')
    }
  },
  {
    path: '/warehouses/:warehouseId/load-types',
    name: 'warehouses.details.loadTypes',
    component: WarehouseDetailsPage,
    props: true,
    meta: {
      preventTitleReset: true,
      requiresAuth: true,
      maxRole: UserRole.OWNER,
      title: i18n.global.t('routes.pageTitles.warehouseLoadTypes')
    }
  },
  {
    path: '/warehouses/:warehouseId/docks',
    name: 'warehouses.details.docks',
    component: WarehouseDetailsPage,
    props: true,
    meta: {
      preventTitleReset: true,
      requiresAuth: true,
      maxRole: UserRole.OWNER,
      title: i18n.global.t('routes.pageTitles.warehouseDocks')
    }
  },
  {
    path: '/warehouses/:warehouseId/loadtypes',
    name: 'warehouses.details.loadtypes',
    component: WarehouseDetailsPage,
    props: true,
    meta: {
      preventTitleReset: true,
      requiresAuth: true,
      maxRole: UserRole.OWNER,
      title: i18n.global.t('routes.pageTitles.warehouseLoadTypes')
    }
  },
  {
    path: '/warehouses/:warehouseId/forms',
    name: 'warehouses.details.forms',
    component: WarehouseDetailsPage,
    props: true,
    meta: {
      preventTitleReset: true,
      requiresAuth: true,
      maxRole: UserRole.OWNER,
      title: i18n.global.t('routes.pageTitles.warehouseFieldsForms')
    }
  },
  {
    path: '/warehouses/:warehouseId/settings',
    name: 'warehouses.details.settings',
    component: WarehouseDetailsPage,
    props: true,
    meta: {
      preventTitleReset: true,
      requiresAuth: true,
      maxRole: UserRole.OWNER,
      title: i18n.global.t('routes.pageTitles.warehouseSettings')
    }
  }
];
